import { reportError } from "@jsainsburyplc/id-ui-common";

export const getBlackBoxToken = (formId) => {
  try {
    const bb = window.IGLOO.getBlackbox();
    if (bb && bb.finished) {
      return bb.blackbox;
    } else {
      throw new Error("Blackbox script missing");
    }
  } catch (e) {
    reportError(`${formId} - error occurred during getBlackBoxToken: ${e}`);
  }
};
